var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_1370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.716 18.4544C129.607 18.8332 114.581 21.2323 92.6106 32.0914C54.3511 50.9055 27.8346 85.5032 20.0059 126.667C14.5763 156.34 19.7534 187.781 34.6531 214.298C42.7343 228.692 54.0985 242.582 62.6848 248.895L69.3771 253.82L69.6296 194.473C70.0084 129.192 71.1449 123.005 84.9082 103.433C100.818 80.9576 122.663 70.9823 158.523 70.2247C189.712 69.3408 192.237 68.5832 207.263 53.5572C218.501 42.3192 219.511 40.804 221.658 31.5863C223.047 26.1568 223.552 20.8535 223.047 19.8433C222.668 18.9594 202.086 18.3281 177.716 18.4544Z",
    fill: "#8493CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.823 124.394L123.799 124.394L123.925 150.279L123.799 176.164L173.802 176.164C201.076 176.164 223.93 176.543 224.309 176.922C226.456 179.069 214.46 197.378 204.99 206.595C188.07 223.515 173.044 228.945 141.729 230.208L123.799 230.965L123.799 255.209L123.799 279.453L132.89 280.968C137.815 281.852 148.927 282.104 157.387 281.473C223.425 276.548 274.059 227.682 280.752 162.149C281.888 151.921 280.246 126.793 278.352 124.899C278.1 124.647 243.25 124.394 200.823 124.394Z",
    fill: "#384268"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_1370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ed4a6811a3e0f03b61f696a92594e10.svg";
export { ForwardRef as ReactComponent };